import { Injectable } from "@angular/core";
import { TradeTableDefinitionFactory } from "../../model/TradeTableDefinitionFactory";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RawDataDealAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: TradeTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
